"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/// <reference path="Thumbnails.d.ts" />
const Base64_1 = require("../../javascript/Base64");
const Utilities_1 = require("../../javascript/Utilities");
const Instance_1 = require("../../model/Instance");
const synerisMethods_1 = require("../../../TdWebtoolkitControls/controls/Menu/synerisMethods");
let markup = require("./Thumbnails.tmpl.htm");
let lightboxMarkup = require("./ThumbnailsLightbox.tmpl.htm");
class ThumbnailsImpl {
    static initAsync($elem, options) {
        let synData = ThumbnailsImpl.getData($elem);
        return new Promise((resolve, reject) => {
            if (!synData) {
                require.ensure(["./Thumbnails.tmpl.less"], (require) => {
                    require("./Thumbnails.tmpl.less");
                    synData = $.extend({}, {
                        size: 64,
                        clickBehavior: "Lightbox",
                        showDownloadButton: true,
                        remove: false
                    }, options);
                    if (synData.size < ThumbnailsImpl.MinSize || synData.size > ThumbnailsImpl.MaxSize) {
                        reject(new Error(kendo.format("Thumbnail size must be between {0} and {1} pixels", ThumbnailsImpl.MinSize, ThumbnailsImpl.MaxSize)));
                        return;
                    }
                    synData.getThumbnailInstances = ThumbnailsImpl.getMergedFetchOptions(options.getThumbnailInstances);
                    synData.upload = undefined;
                    if (options.upload) {
                        if (!options.upload.categoryId) {
                            reject(new Error("You must at least pass upload.categoryId when enabling upload."));
                            return;
                        }
                        synData.upload = $.extend({}, { allowDrop: true }, options.upload);
                    }
                    ThumbnailsImpl.setData($elem, synData);
                    $elem.data("guid", Utilities_1.synUtil.getGUID(true));
                    try {
                        $elem.addClass("synThumbnails");
                        ThumbnailsImpl.fetchThumbnailsAsync($elem)
                            .then(() => {
                            if (synData.upload) {
                                ThumbnailsImpl.initUploadButton($elem);
                                if (synData.upload.allowDrop)
                                    ThumbnailsImpl.initDropZone($elem);
                            }
                            resolve();
                        });
                    }
                    catch (e) {
                        $elem.removeData("synThumbnails");
                        reject(e);
                    }
                });
            }
            else
                reject(new Error("Control is already initialized"));
        });
    }
    static refreshAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield ThumbnailsImpl.fetchThumbnailsAsync($elem);
            yield ThumbnailsImpl.initUploadButton($elem);
        });
    }
    static isInitialized($elem) {
        return typeof ThumbnailsImpl.getData($elem) !== undefined;
    }
    static destroy($elem) {
        return $elem.each((idx, elem) => {
            $(elem)
                .removeClass("synThumbnails")
                .empty()
                .removeData("guid")
                .removeData("synThumbnails");
        });
    }
    static getProdSysIcon(formatId) {
        if (formatId === 6)
            return "file_dwg.png";
        else if (formatId === 7)
            return "file_word.png";
        else if (formatId === 8)
            return "file_excel.png";
        else if (formatId === 9)
            return "file_powerpoint.png";
        else if (formatId === 9)
            return "file_powerpoint.png";
        else if (formatId === 20)
            return "file_pdf.png";
        else if (formatId === 23)
            return "file_text.png";
        else if (formatId === 32)
            return "file_visio.png";
        return "file.png";
    }
    static fetchThumbnailsAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = ThumbnailsImpl.getData($elem);
            $elem
                .css("position", "relative")
                .html("<div class='waitAnim'><i class='fa fa-spinner'></i></div>");
            let instances = yield synData.getThumbnailInstances.getThumbnailInstancesFunc();
            let ids = instances.map(i => i.id.valueAsString);
            $elem.trigger("endFetchThumbnailInstances", [ids]);
            let mapInfo = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("Thumbnail") + "/imageViewable/",
                requestData: JSON.stringify(ids)
            });
            let template = kendo.template(markup);
            $elem
                .css("position", "")
                .html("").append($(template({
                synUtil: Utilities_1.synUtil,
                width: synData.size,
                instances,
                viewInfo: mapInfo,
                getProdSysIcon: ThumbnailsImpl.getProdSysIcon,
                guid: $elem.data("guid"),
                size: synData.size,
                enableUpload: synData.upload != undefined,
                uploadDropZone: synData.upload && synData.upload.allowDrop,
                allowRemove: synData.remove === "Delete" || synData.remove === "Unlink" && synData.getThumbnailInstances.parentId
            })));
            $elem.find("div.waitAnim").each((idx, elem) => {
                let $waitAnim = $(elem);
                let $viewLink = $waitAnim.next(".viewLink");
                let $removeButton = $viewLink.next(".removeButton");
                let $imgTmp = $(new Image());
                $imgTmp
                    .off("load").on("load", () => {
                    $waitAnim.remove();
                    $viewLink.show();
                    if (synData.remove !== false)
                        $removeButton.show();
                })
                    .on("error", () => {
                    $waitAnim.remove();
                    $viewLink.addClass("error").show();
                    if (synData.remove !== false)
                        $removeButton.show();
                })
                    .prop("src", $viewLink.children("img").prop("src"))
                    .each((idx, iElem) => {
                    if (iElem.complete)
                        $imgTmp.trigger("load");
                });
            });
            if (synData.remove !== false) {
                $elem.find("div.removeButton").off("click").on("click", (evt) => {
                    const $thumbnail = $(evt.target).closest(".thumbnailContainer");
                    const id = $thumbnail.attr("data-id");
                    if (synData.remove === "Delete") {
                        synerisMethods_1.synerisMethods.cefunc["24"].impl([id], undefined, undefined, (success) => {
                            if (success)
                                ThumbnailsImpl.refreshAsync($elem);
                        });
                    }
                    else if (synData.remove === "Unlink" && synData.getThumbnailInstances.parentId) {
                        const relId = parseInt($thumbnail.attr("data-relid"), 10);
                        if (Number.isNaN(relId)) {
                            Utilities_1.synUtil.Notifications.error("Thumbnail cannot be unlinked, see console for details.");
                            // eslint-disable-next-line no-console
                            console.error("Instances were not fetched with structure information (cgdocstructure.structuretype) and can therefore not be unlinked. Please change the fetching code such that feched instances contain their relId in cgdocstructure.structuretype.");
                        }
                        else {
                            synerisMethods_1.synerisMethods.cefunc["25"].impl([id], synData.getThumbnailInstances.parentId, relId || synData.getThumbnailInstances.relId, (success) => {
                                if (success)
                                    ThumbnailsImpl.refreshAsync($elem);
                            });
                        }
                    }
                });
            }
            $elem.find("a.viewLink").off("click").on("click", (e) => {
                ThumbnailsImpl.openThumbnail($(e.target), synData, mapInfo);
            });
            $elem.find("a.viewLink").off("click").on("click", (e) => {
                ThumbnailsImpl.openThumbnail($(e.target), synData, mapInfo);
            });
        });
    }
    static createMultiAsync($elem, mapGuidToFileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = ThumbnailsImpl.getData($elem);
            Utilities_1.synUtil.beginAjaxProgress();
            try {
                let templateJSON = yield Utilities_1.synUtil.getAJAXDataAsync({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("InstanceTemplate") + synData.upload.categoryId.toString() + "/4"
                });
                let template = yield Instance_1.Instance.fromJSON(templateJSON);
                let changedFields = [];
                if (synData.upload.fields) {
                    for (let prop in synData.upload.fields)
                        template.items[prop].value = synData.upload.fields[prop];
                    changedFields = Object.keys(synData.upload.fields);
                }
                let createRequestOptions = {
                    template: JSON.stringify(template.toJSON()),
                    changedFields: JSON.stringify(changedFields),
                    fileGUIDs: JSON.stringify(Object.keys(mapGuidToFileName))
                };
                if (synData.upload.parentId)
                    createRequestOptions.parentId = synData.upload.parentId;
                if (synData.upload.relId)
                    createRequestOptions.parentRelId = synData.upload.relId.toString();
                let importResult = yield Utilities_1.synUtil.getAJAXDataAsync({
                    url: Utilities_1.synUtil.getWSUrl("InstanceCreateMultiple"),
                    method: "PUT",
                    requestData: createRequestOptions
                });
                let failedImports = [];
                let successGuids = [];
                for (let fileGUID in importResult) {
                    let resultItem = importResult[fileGUID];
                    if (resultItem.success)
                        successGuids.push(fileGUID);
                    else
                        failedImports.push({
                            fileGUID,
                            filename: mapGuidToFileName[fileGUID],
                            error: resultItem.error.ErrorDisplayMessage
                        });
                }
                if (failedImports.length === 0)
                    Utilities_1.synUtil.Notifications.success(Object.keys(importResult).length + " " + Utilities_1.synUtil.Strings.getValue("savedmultinew"));
                else {
                    let $ul = $("<ul></ul>");
                    $.each(failedImports, (_idx, failedImport) => {
                        $ul.append($("<li></li>").text(failedImport.filename + " (" + failedImport.error + ")"));
                    });
                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("guimultidocnew.error") + $ul.html(), { autoHideAfter: 10000 });
                }
                yield ThumbnailsImpl.refreshAsync($elem);
            }
            finally {
                Utilities_1.synUtil.endAjaxProgress();
            }
        });
    }
    static importFilesAsync($elem, e) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = ThumbnailsImpl.getData($elem);
            let files = e.dataTransfer.files || e.files;
            let filesToAppend = [];
            let base64FileNames = [];
            for (let i = 0; i < files.length; ++i) {
                let filename = Utilities_1.synUtil.getFileName(files[i].name);
                let dotIdx = filename.lastIndexOf(".");
                if (dotIdx === -1) {
                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("webtoolktipuploadnofiletype"));
                    continue;
                }
                else if (filename.substring(dotIdx + 1) === "lnk")
                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("webtoolkituploadnolinks"));
                else if (files[i].size === 0)
                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("ERROR_37|1008"));
                else if (files[i].size >= 2147483648)
                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("ERROR_200024|5"));
                else {
                    base64FileNames.push(filename);
                    filesToAppend.push(files[i]);
                }
            }
            if (filesToAppend.length > 0) {
                let formData = new FormData();
                let guid = $elem.data("guid");
                formData.append("sessionGUID", guid);
                formData.append("base64FileNames", Base64_1.Base64.encode(base64FileNames.join("|")));
                for (let file of filesToAppend)
                    formData.append("files", file);
                Utilities_1.synUtil.beginAjaxProgress();
                try {
                    let result = yield Utilities_1.synUtil.getAJAXDataAsync({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("ContentUpload"),
                        requestData: formData,
                        contentType: false,
                        processData: false
                    });
                    let mapGuidToFileName = {};
                    for (let file of filesToAppend) {
                        let guidKey = file.name + "_" + guid;
                        mapGuidToFileName[result[guidKey]] = file.name;
                    }
                    yield ThumbnailsImpl.createMultiAsync($elem, mapGuidToFileName);
                }
                finally {
                    Utilities_1.synUtil.endAjaxProgress();
                }
            }
        });
    }
    static initUploadButton($elem) {
        let $upload = $elem.children(".synUploadDiv");
        $upload
            .on("beginUpload", () => {
            Utilities_1.synUtil.beginAjaxProgress();
        })
            .on("uploadCancelled uploadError uploadSuccess", () => {
            Utilities_1.synUtil.endAjaxProgress();
        })
            .on("uploadComplete", (event) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let fileGuids = $upload.synUpload("getFileGuids");
            let mapGuidToFileName = {};
            for (let fileGuid of fileGuids)
                mapGuidToFileName[fileGuid] = $upload.synUpload("getFileNameFromGuid", fileGuid);
            yield ThumbnailsImpl.createMultiAsync($elem, mapGuidToFileName);
        }))
            .synUpload({
            allowMultiple: true,
            showFileList: false,
            sessionGUID: $elem.data("guid")
        });
    }
    static initDropZone($elem) {
        let htmlElem = $elem[0];
        htmlElem.ondragenter = (e) => ThumbnailsImpl.toggleDropZone($elem, true);
        htmlElem.ondragleave = (e) => ThumbnailsImpl.toggleDropZone($elem, true);
        htmlElem.ondragover = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.dataTransfer.dropEffect = "copy";
            ThumbnailsImpl.toggleDropZone($elem, true);
        };
        htmlElem.ondrop = (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            ThumbnailsImpl.toggleDropZone($elem, false);
            yield ThumbnailsImpl.importFilesAsync($elem, e);
        });
    }
    static toggleDropZone($elem, enable) {
        $elem.children(".dropOverlay").css("display", enable ? "block" : "none");
    }
    static fitImage($image) {
        if (!$image || !$image.length)
            return;
        let $imgTmp = $(new Image());
        $imgTmp
            .off("load").on("load", () => {
            $image.next(".lightBoxWaitAnim").css("display", "none");
            let w = $imgTmp.prop("naturalWidth");
            let h = $imgTmp.prop("naturalHeight");
            let wContainer = $image.parent().innerWidth();
            let hContainer = $image.parent().innerHeight();
            let factor = Math.min(wContainer / w, hContainer / h);
            if (factor < 1) {
                $image.css({
                    "width": Math.floor(w * factor).toString() + "px",
                    "height": Math.floor(h * factor).toString() + "px"
                });
            }
            else {
                $image.css({
                    "width": "",
                    "height": ""
                });
            }
        })
            .on("error", () => {
            $image.next(".lightBoxWaitAnim").css("display", "none");
            $image.css({
                "width": "16px",
                "height": "16px",
            });
        })
            .prop("src", $image.prop("src"))
            .each((idx, iElem) => {
            if (iElem.complete)
                $imgTmp.trigger("load");
        });
    }
    static openLightbox($viewLink, synData) {
        let $curContainer = $viewLink.closest(".thumbnailContainer");
        let id = $curContainer.attr("data-id");
        let $thumbnailsControl = $viewLink.closest(".synThumbnails");
        let $allContainters = $thumbnailsControl.find(".thumbnailContainer.openLightBox");
        require.ensure(["./ThumbnailsLightbox.tmpl.less"], (require) => {
            require("./ThumbnailsLightbox.tmpl.less");
            let wndData = Utilities_1.synUtil.popupWindow({
                actions: [],
                modal: true,
                preventCloseOnEscpae: false
            });
            let $window = $("#" + wndData.windowID);
            $(document).off("keydown.synLightbox").on("keydown.synLightbox", (e) => {
                if (e.which === 27) {
                    $window.data("kendoWindow").close();
                    $(document).off("keydown.synLightbox");
                    $(window).off("resize.synLightbox");
                }
                else if (e.which === 37)
                    wndData.contentDiv.find(".lightBoxNav.prev").trigger("click");
                else if (e.which === 39)
                    wndData.contentDiv.find(".lightBoxNav.next").trigger("click");
            });
            $(window).off("resize.synLightbox").on("resize.synLightbox", () => {
            });
            $window.data("kendoWindow").maximize();
            $window
                .closest(".k-window")
                .css({
                "padding-top": "0",
                "height": "100%"
            })
                .addClass("thumbnailsLightbox");
            $window.data("lightBoxArray", $allContainters
                .toArray()
                .map((elem) => {
                return {
                    id: $(elem).attr("data-id"),
                    name: $(elem).attr("title")
                };
            }));
            $window.data("lightBoxIndex", $allContainters.index($curContainer));
            let lightboxTmpl = kendo.template(lightboxMarkup);
            wndData.contentDiv
                .append(lightboxTmpl({
                name: $viewLink.closest(".thumbnailContainer").attr("title"),
                fullImgUrl: Utilities_1.synUtil.getWSUrl("Thumbnail") + id + "/full/",
                showDownloadButton: synData.showDownloadButton
            }));
            let $waitAnim = wndData.contentDiv.find(".lightBoxWaitAnim").css("display", "");
            let $img = wndData.contentDiv.find("img.fullImg");
            ThumbnailsImpl.fitImage($img);
            $(window).off("resize.synLightbox").on("resize.synLightbox", () => {
                ThumbnailsImpl.fitImage($img);
            });
            wndData.contentDiv.find("div.lightBoxNav").on("click", (e) => {
                let curIdx = $window.data("lightBoxIndex");
                let arr = $window.data("lightBoxArray");
                // wrap around
                if ($(e.target).closest(".lightBoxNav").hasClass("prev")) {
                    if (--curIdx < 0)
                        curIdx = arr.length - 1;
                }
                else
                    curIdx = ++curIdx % arr.length;
                $waitAnim.css("display", "");
                $img.attr("src", Utilities_1.synUtil.getWSUrl("Thumbnail") + arr[curIdx].id + "/full/");
                ThumbnailsImpl.fitImage($img);
                wndData.contentDiv.find("a.downloadLink > span.name").text(arr[curIdx].name);
                $window.data("lightBoxIndex", curIdx);
                $window.data("lightBoxArray", arr);
            });
            wndData.contentDiv.find("a.downloadLink").on("click", (e) => {
                let curIdx = $window.data("lightBoxIndex");
                let arr = $window.data("lightBoxArray");
                Utilities_1.synUtil.viewInstance({ id: arr[curIdx].id, contentType: 1, done: (b) => { } });
            });
            $("<i class='fa fa-close'></i>")
                .on("click", () => {
                $window.data("kendoWindow").close();
                $(document).off("keydown.synLightbox");
                $(window).off("resize.synLightbox");
            })
                .appendTo(wndData.contentDiv);
        });
    }
    static openThumbnail($viewLink, synData, mapInfo) {
        let id = $viewLink.closest(".thumbnailContainer").attr("data-id");
        if (synData.clickBehavior === "Lightbox") {
            if (mapInfo[id].handler === "image") {
                ThumbnailsImpl.openLightbox($viewLink, synData);
                return;
            }
        }
        if (mapInfo[id].handler !== "none") {
            Utilities_1.synUtil.viewInstance({
                id,
                contentType: 1,
                done: (b) => { }
            });
        }
    }
    static getDefaultFetchFunc(parentId, relId, categoryIds) {
        return () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let requestOpts = { node: parentId, parentDepth: 0, childDepth: 1 };
            if (relId)
                requestOpts.allowedRelIDs = [relId.toString()];
            if (categoryIds)
                requestOpts.allowedCategories = categoryIds.map(c => c.toString());
            let graph = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("Graph"),
                requestData: JSON.stringify(requestOpts)
            });
            let instances = [];
            let mapInstances = {};
            for (const node of graph.nodes)
                if (node.data.id !== parentId)
                    mapInstances[node.data.id] = yield Instance_1.Instance.fromJSON(node.data.instance);
            for (const edge of graph.edges) {
                if (edge.data.source === parentId && mapInstances[edge.data.target]) {
                    instances.push(mapInstances[edge.data.target]);
                    delete mapInstances[edge.data.target];
                }
            }
            instances.sort((a, b) => b.items["cgdocument.lastchangedate"].valueToNumber(-Number.MAX_VALUE) - a.items["cgdocument.lastchangedate"].valueToNumber(-Number.MAX_VALUE));
            return instances;
        });
    }
    static getMergedFetchOptions(getThumbnailInstances) {
        let func;
        let parentId;
        let relId;
        let categoryIds;
        if (getThumbnailInstances) {
            func = getThumbnailInstances.getThumbnailInstancesFunc;
            parentId = getThumbnailInstances.parentId;
            relId = getThumbnailInstances.relId;
            categoryIds = getThumbnailInstances.categoryIds;
        }
        if (!func) {
            if (!parentId)
                throw new Error("You must at least pass getThumbnailInstances.parentId when relying on the default implementation for getThumbnailInstances.getThumbnailInstancesFunc");
            func = ThumbnailsImpl.getDefaultFetchFunc(parentId, relId, categoryIds);
        }
        let result = {
            getThumbnailInstancesFunc: func,
            parentId
        };
        if (relId)
            result.relId = relId;
        if (categoryIds)
            result.categoryIds = categoryIds;
        return result;
    }
    static setData($this, data) {
        $this.data("synThumbnails", data);
    }
    static getData($this) {
        return $this.data("synThumbnails");
    }
}
ThumbnailsImpl.MinSize = 64;
ThumbnailsImpl.MaxSize = 256;
// Dispatcher code
(($) => {
    $.fn.synThumbnails = function () {
        if (!arguments.length || typeof arguments[0] === "object")
            return ThumbnailsImpl.initAsync.apply(undefined, [this].concat(Array.prototype.slice.call(arguments)));
        else if (typeof arguments[0] === "string" && ThumbnailsImpl[arguments[0]])
            return ThumbnailsImpl[arguments[0]].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else
            $.error("Method " + arguments[0] + " does not exist on jQuery.synThumbnails");
    };
})(jQuery);
